module.exports = "/fonts/opensanslight.woff2";